import Joi, { getAttachmentsSchema } from "fe-shared/src/helpers/validation";
import { ErrorMessages, FileInterface } from "fe-shared/src/types/common";

export interface CreateInvoiceFormContent {
  isAdjustment: boolean;
  comment: string;
  amount: number;
  attachments: FileInterface[];
}

export const initialContent: CreateInvoiceFormContent = {
  isAdjustment: false,
  attachments: [],
  comment: "",
  amount: 0,
};

export const errorMessages: ErrorMessages = {
  comment: {
    "string.empty": "validation.reasonsRequired",
  },
  amount: {
    "number.base": "validation.amountRequired",
    "number.unsafe": "validation.amountInvalid",
    "number.min": "validation.amountMin",
    "any.invalid": "validation.amountInvalid",
  },
};

const attachmentsShema = getAttachmentsSchema("attachments");

export const getValidationConfig = (subtotal: number) =>
  Joi.object({
    amount: Joi.optional().when("isAdjustment", {
      is: true,
      then: Joi.number().min(-subtotal).invalid(0).required(),
    }),
    comment: Joi.optional().when("isAdjustment", {
      is: true,
      then: Joi.string().required(),
    }),
    attachments: attachmentsShema,
  }).unknown();
